import React from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"

import notFoundImage from '../../resources/images/404_concept_with_desert.png'

export const PageNotFound = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Page Not Found</title>
            </Helmet >

            <div className="wrapper md:align-middle align-baseline justify-center w-full items-center overflow-auto md:h-screen h-auto">
                <section className="gx-container md:h-screen h-auto rounded-md w-1024 flex items-center justify-center">
                    <div className="md:my-6 my-4 py-3 px-4 w-full flex align-middle items-center justify-center text-sm">
                        <div className="flex flex-col items-center lg:w-2/3 md:w-3/4 w-full justify-center align-middle">
                            <div className="w-full relative">
                                <div className="mx-auto flex-shrink-0 flex items-center justify-center w-48 md:w-64 lg:w-64 relative">
                                    <img
                                        src={notFoundImage}
                                        alt="error_image"
                                        className="block text-center m-auto z-10"
                                    />
                                </div>

                                <h1 className="text-9xl md:text-[160px] lg:text-[200px] flex items-center justify-center absolute inset-0 font-bold text-red-200/70 dark:text-red-700/40">
                                    404
                                </h1>
                            </div>

                            <div className="text-center flex flex-col items-center justify-center m-auto text-slate-700 dark:text-slate-200 lg:w-full md:w-full w-full text-sm relative pt-6 md:pt-6 lg:pt-8 pb-4">
                                <div className="w-full flex flex-col align-middle items-center justify-center">
                                    <span className="text-xl block text-red-600 dark:text-red-500 mb-2 silkscreen-regular">
                                        Page Not Found
                                    </span>

                                    <div className="text-sm text-slate-600 dark:text-slate-300 flex flex-col items-center justify-center">
                                        <span>
                                            You’ve reached the edge of the map. <span className="hidden md:inline-flex">It’s all sand and silence out here.</span>
                                        </span>

                                        <div className="flex align-middle items-center w-auto gap-x-1">
                                            Let’s return to a place that feels like

                                            <Link to="/home" className="text-center text-orange-600 hover:text-orange-700 underline">
                                                <span className="flex items-center justify-between">
                                                    <span>
                                                        home
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </React.Fragment >
    )
}